import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center h-screen px-6 bg-gray-200" }
const _hoisted_2 = { class: "w-full max-w-sm p-6 bg-white rounded-md shadow-md" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mt-6 text-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-red-500 text-sm mt-3"
}
const _hoisted_7 = ["disabled"]

import { onMounted, ref } from "vue";
import { FETCH_JWT, LOGIN } from "@/store/auth.module";
import { useStore } from "vuex";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLogin',
  setup(__props) {

const store = useStore();
const router = useRouter();

const isLoading = ref(false);
const errorMessage = ref("");

onMounted(async () => {
  try {
    isLoading.value = true;
    await store.dispatch(FETCH_JWT);
    router.replace("/select");
  } catch {
    isLoading.value = false;
  }
});

async function login() {
  try {
    errorMessage.value = "";
    isLoading.value = true;
    await store.dispatch(LOGIN);
  } catch (error: any) {
    const detail = error?.message ? ` (${error.message})` : "";
    errorMessage.value = `Tidak dapat menghubungkan ke layanan SSO.${detail}`;
    isLoading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/image/logo.webp'),
          alt: "IOM-ITB",
          class: "w-[60px] mr-2"
        }, null, 8, _hoisted_4),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-2xl font-semibold text-gray-700" }, "IOM-Dashboard", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm text-gray-600" }, "Masuk menggunakan akun SSO yang terdaftar di Keycloak.", -1)),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "w-full mt-5 px-4 py-2 text-sm text-center text-white bg-indigo-600 rounded-md focus:outline-none hover:bg-indigo-500",
          disabled: isLoading.value,
          onClick: login
        }, _toDisplayString(isLoading.value ? "Memproses..." : "Masuk dengan SSO"), 9, _hoisted_7)
      ])
    ])
  ]))
}
}

})